export const iconFontAwesomeTransportationHorse = (
	<i className="fa-solid fa-horse"></i>
);
